import {useRef} from "react";
import {useSetState} from "ahooks";
import {message, Switch,} from "antd";
import {SActionBtn, SDrawerOrModal, SFuncModalFormRef, SLowcodeList, SMessage, STableActions} from "shj-components";

import {config} from "./config.tsx";
import {config as systemConfig} from "./sys_config.tsx";
import AddOrEditConfigure from "./addOrEdit";
import {argDelete, argUpdateState, getArgPage, getProductEnums} from "@/services/product.ts";
import {apiData2Table} from "@/utils/data.ts";

const CustomParameter = (props) => {
  const {argTypeFlag} = props
  const listRef = useRef()
  const editRef = useRef<SFuncModalFormRef>({onFinish: undefined});

  const [state, setState] = useSetState(
      {
        exportLoading: false,
        visible: false,
        record: {},
        options: {},
        btnLoading: false,
      })

  const fetchList = ({current, pageSize, query}) => {
    return new Promise((resolve, reject) => {
      getArgPage({
        params: {pageId: current, pageSize},
        data: {
          ...query, argTypeFlag, orderBys: [
            {
              columnName: "id",
              asc: false
            }
          ]
        }
      }).then(res => {
        resolve(apiData2Table(res))
      }).catch(reject)
    })
  }

  const getStatusOptions = async () => {
    const argTypeEnum = await getProductEnums('com.shj.saas.plus.product.enums.ArgManageTypeEnum')
    const statueEnum = await getProductEnums('com.shj.saas.plus.product.enums.StatueEnum')
    setState({options: {argTypeEnum}})
    return Promise.resolve({argTypeEnum, statueEnum})
  }

  const onChangeStatus = (enabled: boolean, id: string) => {
    SMessage.confirm({
      title: `${enabled ? '打开' : '关闭'}开关，将${enabled ? '启用' : '禁用'}参数，是否继续？`,
      okText: '继续',
      content: null,
      onOk: () => {
        return argUpdateState({data: {enabled, idList: [id]}}).then((res: any) => {
          message.success(res.message || '操作成功');
          listRef.current?.reload()
        })
      },
    });
  }

  const onAddOrEdit = (record = {}) => {
    setState({visible: true, record: {...record}})
  }

  const onDel = (id: string) => {
    SMessage.confirm({
      onOk: () => {
        return argDelete(id).then((res: any) => {
          message.success(res.message || '操作成功');
          listRef.current?.reload()
        })
      },
    });
  }

  const onSubmit = () => {
    editRef.current.onFinish?.()
  };

  const onCancel = () => {
    setState({visible: false, btnLoading: false})
  }

  const setLoading = (btnLoading: boolean) => {
    console.log(btnLoading)
    setState({btnLoading})
  }

  const extensions = {
    request: {fetchList, getStatusOptions},
    events: {onAdd: () => onAddOrEdit()},
    customRender: {
      switchRender(v: boolean, record: Record<string, any>) {
        return <Switch checkedChildren="启用" unCheckedChildren="禁用"
                       checked={v} onClick={(checked) => onChangeStatus(checked, record.id)}/>
      },
      jsonRender(v, record) {
        if (record.argType !== 'input') {
          return v?.list?.map(item => item.name)?.join(', ')
        }
      },
      actionRender(_: null, record: Record<string, any>) {
        return <STableActions>
          <SActionBtn onClick={() => onAddOrEdit(record)}>编辑</SActionBtn>
          <SActionBtn danger onClick={() => onDel(record.id)}>删除</SActionBtn>
        </STableActions>
      },
    }
  }

  return (
      <div>
        <SLowcodeList ref={listRef} searchMode={'group'}
                      config={argTypeFlag === 'preset' ? systemConfig : config} {...extensions}/>
        <SDrawerOrModal mode={'modal'}
                        width={500}
                        onCancel={onCancel}
                        onOk={onSubmit}
                        open={state.visible}
                        loading={state.btnLoading}
                        title={(state.record.id ? '编辑' : '新增') + '配置'}
        >

          <AddOrEditConfigure
              editRef={editRef.current}
              {...state.options}
              onCancel={onCancel}
              setLoading={setLoading}
              fn={listRef.current?.reload}
              record={state.record}/>
        </SDrawerOrModal>
      </div>
  );
};

export default CustomParameter;